import { SessionAccess } from './organizationAccess';

export enum Role {
  USER = 'User',
  CASE_OPERATOR = 'Case operator',
  COUNTRY_OPERATOR = 'Country operator',
  OPERATOR = 'Operator',
  MANAGER = 'Manager',
  ADMIN = 'Admin',
  SUPERADMIN = 'Super Admin',
  /** Above Super Admin, held by one person: every right of a Super Admin, plus a few of its own. */
  OWNER = 'Owner'
}

export interface User {
  _id?: string;
  email: string;
  firstName: string;
  lastName: string;
  avatar?: string;
  role?: {
    name: Role,
    level: number
  };
  organization: string;
  organizationId?: string;
  acls?: string[];
  lang: string;
  password?: string;
  createdAt?: Date;
  passwordVerified?: boolean;
  isSuspended: boolean;
  /** Present while a platform team member acts inside a client organisation (organisation access). */
  access?: SessionAccess;
}
